export default __webpack_public_path__ + "bcbad89e052034871397ed6084248b73.svg";